import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NgxCsvParser} from 'ngx-csv-parser';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private http: HttpClient,
    private ngxCsvParser: NgxCsvParser,
  ) {
  }

  async getBlob(url: string): Promise<Blob | undefined> {
    return await firstValueFrom(this.http.get(url, {responseType: 'blob'}));
  }

  async getCsv(url: string): Promise<any[][]> {
    const blob = await this.getBlob(url);
    if (!blob) {
      return [];
    }
    const arrayBuffer = await blob.arrayBuffer();
    const decoder = new TextDecoder('windows-31j');
    const text = decoder.decode(arrayBuffer);
    return this.ngxCsvParser.csvStringToArray(text, ',');
  }

  async post(url: string, parameter: object): Promise<any> {
    return await this.http.post(url, parameter).toPromise();
  }
}
